<template>
  <div class="block-cars-container">
    <div class="cars-wrapper">
      <div
        v-for="(car, index) in cars"
        :key="car.id"
        class="car"
        :class="{
          right: index % 2 !== 0,
          left: index % 2 === 0,
          right_outlander_black_edition:
            car.id === 'outlander_black_edition' && index % 2 !== 0,
        }"
        :id="car.id"
      >
        <div class="container">
          <div class="img_container">

            <div
              v-if="car.label"
              :class="{
                left: index % 2 === 0,
                ['car-label label--type_' + car.label]: true,
              }"
              @click.prevent="() => $emit('call-order', { title1: car.label })"
            ></div>

            <div class="car_title" v-if="car.id !== 'outlander_black_edition'">
              <a
                @click.prevent="() => $emit('call-order', { title1: car.name })"
                class="car_name"
                href="#form_popup"
                :title="car.name"
              >
                <!-- {{ car.id === 'outlander' ? 'Обновленный ' + car.name : car.name }} -->
                {{ car.name }}
              </a>


              <a
                v-if="car.id === 'outlander_7'"
                @click.prevent="
                  () =>
                    $emit('call-order', {
                      title1: car.name,
                      title2: car.price,
                    })"
                class="car_price-container"
                href="#form_popup"
              >
                <span class="car_price car_price-text">
                  Ограниченная партия
                </span>
              </a>

            </div>
            <div
              class="car_title_black"
              v-if="car.id === 'outlander_black_edition'"
            >

              <div
                class="car_title_black__wrapper"
                @click.prevent="() => $emit('call-order', { title1: car.name })"
              >
                <div class="car_title_black__title"></div>
              </div>
            </div>
            <div
              class="car_img"
              :class="{ [`car_img--${car.id}`]: true }"
              @click.prevent="() => $emit('call-order', { title1: car.name })"
            ></div>
            <h4 v-if="car.id === 'pajero_sport'">Официальная поставка автомобилей в РФ</h4>
          </div>
          <div class="info_container">
            <div
              class="about_car"
              @click.prevent="
                () =>
                  $emit('call-order', {
                    title1: `${car.balance} а/м ${car.name} по акции`,
                    title2: `В наличии с ПТС`,
                  })
              "
            >
              {{ getVerbForm(car.balance) }}
              <span>{{ car.balance }} а/м</span> по акции <br />В наличии с ПТС
            </div>
            <div>
              <a
                class="profit_item"
                :key="key"
                :class="key"
                href="#form_popup"
                v-for="(bonus, key) of car.profits"
                @click.prevent="() => $emit('call-order', { title1: bonus })"
              >
                <span>{{ bonus }}</span>
              </a>
            </div>
            <div class="car_btns">
              <a
                v-if="car.price || car.id === 'pajero_sport'"
                class="btn btn-transparent btn--gray"
                href="#stock"
                >Подобрать комплектацию</a
              >
              <a
                v-else
                class="btn btn-transparent btn--gray"
                href="#form_popup"
                @click.prevent="
                  () => $emit('call-order', { title1: 'Оформить предзаказ' })
                "
                >Оформить предзаказ</a
              >
              <a
                class="btn btn-red"
                href="#form_popup"
                @click.prevent="
                  () => $emit('call-order', { title1: `Получить предложение` })
                "
              >
                <span>Получить предложение</span>
              </a>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CarsInfo from "../common/cars-info";

export default {
  name: "block-cars",
  data() {
    return {
      cars: CarsInfo.CARS,
    };
  },
  methods: {
    getVerbForm(num) {
      const arr = num.toString().split("");
      if (arr[arr.length - 1] === "1" && num !== 11) {
        return "Остался";
      }
      return "Осталось";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/index.scss";

.block-cars-container {
  padding-bottom: 40px;
}

.btn {
  span {
    white-space: pre-wrap;
  }

  &--gray {
    background-color: #686d71;

    color: #fff;
    &:hover {
      background: #858585;
      border-color: #858585;
    }
  }
}

.container {
  margin: 0px auto;
  max-width: 1140px;
  position: relative;
  padding: 0px 15px;
  text-align: center;
}

.car {
  .container {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    @media (max-width: 767px) {
      flex-wrap: wrap;
    }
  }

  .car-label {
    position: absolute;
    top: 40px;
    /* left: -120px; */
    right: 0;

    @media (max-width: 1370px) {
    }
    @media (max-width: 1010px) {
      top: 60px;
    }
    @media (max-width: 630px) {
      top: 70px;
    }
    @media (max-width: 370px) {
      top: 100px;
    }
    @media (max-width: 320px) {
      top: 60px;
    }
  }

  .car-label.right {
    right: 20px;
  }

  .style {
    position: absolute;
    top: 50px;
    right: 20px;
  }

  .style.left {
    left: 20px;

    @media (max-width: 767px) {
      left: inherit;
    }
  }
}

.car.left {
  background: url(../img/car_bg_left.png) left no-repeat;
  margin: 70px 0 0 0;

  @media (max-width: 320px) {
    margin: 40px 0 0 0;
  }

  @media (max-width: 767px) {
    background: none;
  }
}

.car.right {
  background: url(../img/car_bg_right.png) right no-repeat;
  margin: 70px 0 0 0;

  @media (max-width: 320px) {
    margin: 40px 0 0 0;
  }

  @media (max-width: 767px) {
    background: none;
  }
}

.img_container {
  width: 700px;
  position: relative;

  @media (max-width: 767px) {
    width: 100%;
  }

  @media (max-width: 991px) and (min-width: 768px) {
    width: 100%;
  }
}

.info_container {
  background: white;
  width: 390px;
  padding: 40px;
  box-shadow: 0 0 25px 5px rgba(0, 0, 0, 0.17);

  @media (max-width: 380px) {
    padding: 40px 20px;
  }

  @media (max-width: 767px) {
    width: 100%;
    order: 1;
  }

  @media (max-width: 991px) and (min-width: 768px) {
    width: 100%;
  }
}

.about_car {
  font-size: 15px;
  color: #686d71;
  font-weight: 500;
  line-height: 30px;
  cursor: pointer;

  span {
    font-size: 22px;
    color: black;
    font-weight: 600;
  }
}

.profit_item {
  display: flex;
  align-items: center;
  text-align: center;
  font-size: 17px;
  font-weight: 500;
  position: relative;
  margin-top: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid #ccc;

  span {
    flex: 1;
  }

  &:hover {
    color: #ed0000;
  }

  @media (max-width: 320px) {
    font-size: 14px;
    margin-top: 20px;
    padding-bottom: 20px;
  }

  &:last-child {
    border: none;
  }

  &::before {
    content: url(../img/percent.png);
    margin-right: 15px;
  }

  &.garanty::before {
    content: url(../img/garanty.png);
  }
  &.pts::before {
    content: url(../img/garanty.png);
  }
  &.tradein::before {
    content: url(../img/2xbonus.png);
  }
  &.secure::before {
    content: url(../img/car_check.png);
  }
  &.ico1::before {
    content: url(../img/ico1.png);
  }
  &.ico2::before {
    content: url(../img/ico2.png);
  }
  &.ico3 {
    color: #ed0000;
    &::before {
      content: url(../img/ico3.png);
    }
  }
  &.signal::before {
    content: url(../img/signal.png);
  }
  &.guarantee::before {
    content: url(../img/garanty.png);
  }
}

.car_title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 50px;

  @media (max-width: 320px) {
    padding-bottom: 10px;
  }

  @media (max-width: 767px) {
    flex-wrap: wrap;
  }

  @media (max-width: 991px) and (min-width: 768px) {
    padding-bottom: 100px;
  }
}

.car_name {
  font-size: 22px;
  font-weight: 700;
  text-transform: uppercase;

  span {
    font-size: .7em;
  }

  &:hover {
    color: #ed0000;
  }

  @media (max-width: 320px) {
    font-size: 20px;
  }

  @media (max-width: 767px) {
    width: 100%;
  }

  @media (max-width: 991px) and (min-width: 768px) {
    font-size: 20px;
  }
}

.car_price-container {
  font-size: 40px;
  font-weight: 700;
  text-transform: uppercase;
  color: #ed0000;
  padding: 0 35px;

  @media (max-width: 320px) {
    font-size: 30px;
  }

  @media (max-width: 767px) {
    font-size: 36px;
    padding: 0;
    order: 1;
    width: 100%;
  }

  @media (max-width: 991px) and (min-width: 768px) {
    font-size: 24px;
    padding: 0 30px;
    white-space: nowrap;
  }
}

.car_price {
  // text-decoration: line-through;

  &_outlander {
    text-decoration: none;
  }
  &-text {
    font-size: 30px;
  }
  &-special {
    font-weight: bold;
    font-size: 20px;
    text-transform: uppercase;
    color: #ed0000;
  }
}

.car_btns {
  a {
    margin-top: 10px;

    @media (max-width: 320px) {
      font-size: 13px;
    }

    @media (max-width: 360px) {
      font-size: 15px;
    }

    span {
      font-weight: 700;
    }
  }
}

@each $label in "fix_price" {
  .label--type_#{$label} {
    width: 240px;
    height: 100px;
    background-image: url("../img/#{$label}.png");
    background-size: contain;
    background-repeat: no-repeat;
    cursor: pointer;

    @media (max-width: 1415px) {
      width: 220px;
      height: 80px;
    }
    @media (max-width: 1230px) {
      width: 200px;
      height: 80px;
    }
    @media (max-width: 660px) {
      width: 130px;
      height: 70px;
    }
    @media (max-width: 767px) {
      left: 0;
    }
    @media (max-width: 520px) {
      width: 100px;
      height: 40px;
      top: 85px;
    }
    @media (max-width: 320px) {
      width: 70px;
      top: 70px;
    }
  }
}


.car {
  &:nth-child(2n) {
    .container {
      display: flex;
      flex-direction: row-reverse;

      .car_title {
        flex-direction: row-reverse;
      }
    }
  }
}

.car_img {
  background-repeat: no-repeat;
  background-position: 50% 50%;
  cursor: pointer;

  @each $car in "outlander", "pajero_sport", "eclipse", "l200", "asx", "pajero",
    "outlander_black_edition", "asxbe", "outlander_7", "pajero4", "x_pander"
  {
    &--#{$car} {
      height: 30vw;
      max-height: 450px;
      background-image: url("../img/#{$car}.png");
      background-size: contain;

      @media (max-width: 767px) {
        height: 50vw;
      }
    }
  }
  &--outlander_7 {
    height: 25vw;
  }
  &--asxbe {
    background-size: cover;
  }
  &--asx {
    margin-top: -50px;
    transform: scale(-1, 1);
  }
}

.car_title_black {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 991px) and (min-width: 768px) {
    margin-bottom: 50px;
  }
  @media (max-width: 767px) {
    flex-direction: column;
    margin-bottom: 20px;
  }

  &__wrapper {
    height: 70px;
    width: 36%;
    padding-top: 5px;
    cursor: pointer;
    @media (max-width: 991px) and (min-width: 768px) {
      height: 50px;
    }
    @media (max-width: 767px) {
      width: 65%;
    }
  }

  &__title {
    height: 100%;
    background-image: url("../img/logo-lined-black.png");
    background-repeat: no-repeat;
    background-size: contain;
  }

  &__subtitle {
    font-size: 40px;
    font-weight: 700;
    text-transform: uppercase;
    color: #ed0000;
    padding: 0 35px;
    cursor: pointer;

    @media (max-width: 320px) {
      font-size: 30px;
    }

    @media (max-width: 767px) {
      font-size: 36px;
      padding: 0;
      order: 1;
      width: 100%;
    }

    @media (max-width: 991px) and (min-width: 768px) {
      font-size: 24px;
      padding: 0 30px;
      white-space: nowrap;
    }
  }
}

.car.right_outlander_black_edition {
  background: url(../img/fon.png) right no-repeat;
  // background-position-x: 111%;
  background-position-y: 108px;
  @media (max-width: 1600px) {
    background-position-x: 111%;
  }
  @media (max-width: 1200px) {
    background-position-y: 90px;
  }
  @media (max-width: 767px) {
    background: #fff;
  }
}

#asxbe {
  .style {
    top: 80px;
    right: 10px;
  }
}

#outlander_black_edition {
  .car_title_black {
    align-items: flex-start;
  }
}

@media(max-width: 767px) {
  .car_price {
    &-special {
      width: 100%;
      text-align: center;
    }
  }
}
</style>
